<template>
  <v-content
    style="background-color:#FFFFFF"
  >
    <router-view />

    <!-- <dashboard-core-footer /> -->
    <bottom-navigation />
  </v-content>
</template>

<script>
  export default {
    name: 'DashboardCoreView',

    components: {
      DashboardCoreFooter: () => import('./Footer'),
      BottomNavigation: () => import('./BottomNavigation'),
    },
    mounted () {
      this.$store.subscribe((mutation, state) => {
        if (mutation.type === 'SET_SITE_FONT_FAMILY') {
          this.$el.style.fontFamily = `"${state.site_font_family}", sans-serif`
          // this.$el.style.fontFamily = '"Yusei Magic", sans-serif'
        }
      })
    },
  }
</script>
<style lang="scss">
  /* Google fontsで導入したいfonts から@importのコードを取得 */
  @import url('https://fonts.googleapis.com/css2?family=Dela+Gothic+One&family=DotGothic16&family=Hina+Mincho&family=Kiwi+Maru:wght@300;400;500&family=Klee+One:wght@400;600&family=Kosugi+Maru&family=M+PLUS+1+Code:wght@100;200;300;400;500;600;700&family=M+PLUS+1p:wght@100;300;400;500;700;800;900&family=M+PLUS+Rounded+1c:wght@100;300;400;500;700;800;900&family=Noto+Sans+JP:wght@100;300;400;500;700;900&family=Noto+Serif+JP:wght@200;300;400;500;600;700&family=Rampart+One&family=RocknRoll+One&family=Sawarabi+Gothic&family=Shippori+Mincho:wght@400;500;600;700;800&family=Yusei+Magic&display=swap');
</style>
